import { LitElement, html } from '@hh/global.js'

class ProductDescriptionTruncated extends LitElement {
  static properties = {}

  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.handleViewMoreButton()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  handleViewMoreButton() {
    const buttonEl = this.querySelector('.js-product-description-truncated-view-btn')

    buttonEl?.addEventListener('click', () => {
      const truncatedEl = this.querySelector('.product-description__truncated')
      const fullDescriptionEl = this.querySelector('.product-description__full')

      truncatedEl?.classList.add('hidden')
      fullDescriptionEl?.classList.remove('hidden')
    })
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('product-description-truncated', ProductDescriptionTruncated)
